export const createErrorRegistry = ({
  criticalTypes = [],
  ownedPredicates = [],
  selectIsInitialized = () => true,
} = {}) => ({
  criticalTypes,
  ownedPredicates,
  selectIsInitialized,
});

const isOwned = (registry, error) => registry.ownedPredicates.some((predicate) => predicate(error));

const lastVisibleError = (state, registry) =>
  state.errors.filter((error) => !isOwned(registry, error)).last() || null;

export const selectPageError = (state, registry) =>
  registry.selectIsInitialized(state) ? null : lastVisibleError(state, registry);

export const selectModalError = (state, registry) =>
  registry.selectIsInitialized(state) ? lastVisibleError(state, registry) : null;
